import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

// AdministrationLayout — the shell for the Administration workflow (approved IA §5). It owns the
// section header, the area/tab navigation, and page framing; the feature components rendered through
// <Outlet /> own their grids, dialogs, data loading and API calls.
//
// Administration currently contains ONE area — Franchise Administration — whose children are
// Franchise Configuration and LK/SI Eligibility Administration. When a second area (Application
// Administration) graduates in, it renders as a sibling of "Franchise Administration" here; the
// per-area tab set is scoped to its area, so nothing below changes.
export default function AdministrationLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeArea = location.pathname.includes("/administration/eligibility") ? "eligibility"
    : location.pathname.includes("/administration/onboarding") ? "onboarding"
      : location.pathname.includes("/administration/inventory") ? "inventory"
        : "franchise";
  const handleAreaChange = (event, next) => {
    navigate(next === "eligibility" ? "/administration/eligibility"
      : next === "onboarding" ? "/administration/onboarding"
        : next === "inventory" ? "/administration/inventory"
          : "/administration/franchise");
  };

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Box sx={{ mt: 1, mb: 0.5 }}>
        <Typography variant="h5" component="h1" fontWeight={600}>
          Administration
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Franchise and application administration.
        </Typography>
      </Box>

      {/* Current area under Administration. */}
      <Typography variant="subtitle2" sx={{ mt: 1.5, fontWeight: 600 }}>
        Franchise Administration
      </Typography>
      <Tabs
        value={activeArea}
        onChange={handleAreaChange}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}
      >
        <Tab label="Franchise Configuration" value="franchise" />
        <Tab label="LK/SI Eligibility Administration" value="eligibility" />
        <Tab label="Onboarding Candidates" value="onboarding" />
        <Tab label="Franchise Inventory" value="inventory" />
      </Tabs>

      <Outlet />
    </Box>
  );
}
